module.exports = __webpack_public_path__ + "img/Beehive-Logo-Colour.60dd8845.svg";